import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { localeService } from '../../services';
import CheckoutHeader from '../../components/CheckoutHeader';
import { KompisPrompt } from '@inter-ikea-kompis/react-components';

type Props = {
	showPrompt: boolean;
	onClick: (event: CustomEvent) => void;
};

const CheckoutHeaderContainer = styled.div`
	position: absolute;
	top: 0;
	width: 100%;
	z-index: 10;
`;

const NoValidLink: FunctionComponent<Props> = (props) => {
	const { onClick } = props;
	return (
		<>
			<CheckoutHeaderContainer>
				<CheckoutHeader></CheckoutHeader>
			</CheckoutHeaderContainer>
			<KompisPrompt
				heading={localeService.getTranslation('noLongerValidLink')}
				primaryButtonLabel={'IKEA.com'}
				onButtonClick={(event: CustomEvent) => onClick && onClick(event)}
				visible={props.showPrompt}
				theme={SkapaTheme}
				disableIframeSticky={false}
			></KompisPrompt>
		</>
	);
};

export default NoValidLink;
